import Customer from 'models/customer';
import customerApi from 'api/customer';
import CustomerContact from 'models/customerContact';
import CustomerPools from './systemWidget';
import Dealer from 'models/dealer';
import dealerApi from 'api/dealer';
import DeleteConfirm from 'components/forms/deleteConfirm';
import IntlWrapper from 'components/layout/intlWrapper';
import EditableTextField from 'components/forms/editableTextField';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import FooterDeleteButton from 'components/layout/footerDeleteButton';
import FullAddress from 'components/forms/FullAddress';
import Header from 'components/layout/header';
import Loader from 'components/loader';
import PageFooter from 'components/layout/pageFooter';
import path from 'path';
import phoneFormat from 'helpers/phoneFormat';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import ValidationGroup, {isValidEmail, isValidPhone} from 'helpers/validation';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import LayoutCheckbox from '../../components/forms/layoutCheckbox';
import NoteFooter from 'components/notes/NoteFooter';
import Link from 'components/layout/link';
import {countries, brand} from 'helpers/constants';
import EditableCheckbox from 'components/forms/editableCheckbox';
import cloneDeep from 'lodash/cloneDeep';
import LayoutSelect from '../../components/forms/layoutSelect';
import {phoneDescriptionLookup} from 'helpers/constants';

function formatAddress(cust) {
  return {
    Line1: cust.address1,
    Line2: cust.address2,
    City: cust.city,
    Province: cust.state,
    PostalCode: cust.zip,
  };
}

function unformatAddress(address) {
  return {
    address1: address.Line1,
    address2: address.Line2,
    city: address.City,
    state: address.Province,
    zip: address.PostalCode,
  };
}

function onlyNumbers(xs) {
  return (xs || '').split('')
    .map(x => parseInt(x))
    .filter(x => !isNaN(x))
    .join('');
}

// Register in router
let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');

  let _id;
  let _contactid;

  if (params.id) {
    _id = parseInt(params.id.split('.')[0]);
    _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
  }

  ReactDOM.render(
    <IntlWrapper>
      <WrappedCustomerEditPage
        id={_id}
        contactId={_contactid}
        addContact={window.location.hash.indexOf('add-contact') !== -1}/>
    </IntlWrapper>, container
  );
  events.publish('page-change', {page: 'customer'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/add', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'customer/:id/edit', handler: routeUtils.requireAuth(render)}]);

// Page object
class CustomerEditPage extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    contactId: PropTypes.number,
    addContact: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      dealer: new Dealer({}),
      customer: new Customer({
        id: props.id,
        customerContacts: [new CustomerContact({})],
        customerContactsWorkingCopy: [new CustomerContact({})],
        pools: [],
      }),
      address: '',
      hasFoundDupe: false,
      lastAddress: null,
      submitted: false,
      organization: [false],
      links: [
        'http://discussions.justice.gc.ca/eng/acts/E-1.6/FullText.html',
        'http://discussions.justice.gc.ca/eng/regulations/SOR-2012-36/FullText.html',
        'https://crtc.gc.ca/eng/com500/faq500.htm',
        'https://crtc.gc.ca/eng/com500/videot1.htm',
      ],
    };
  }

  componentWillMount() {
    this.group = new ValidationGroup(this.save);

    let apis = [];

    apis.push(customerApi.getNextAccountNumber());
    apis.push(dealerApi.getDealer(session.getUser().dealerId));
    if (this.props.id) {
      apis.push(customerApi.getCustomer(this.props.id));
    }
    Promise.all(apis)
      .then(([nextAccountNumber, dealer, customer]) => {
        customer = customer || this.state.customer;
        if (!this.props.id) {
          customer.defaultAccountNum = nextAccountNumber;
          customer.state = dealer.state;
        }
        if (!customer.state) {
          customer.state = dealer.state;
        }

        customer.customerContactsWorkingCopy = cloneDeep(customer.customerContacts);

        this.setState({
          loaded: true,
          dealer: dealer,
          address: formatAddress(customer),
          customer: customer,
          organization: customer.customerContacts.map(x => !!x.organization),
        });
        if (this.props.addContact) {
          this.addContact();
          window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        }
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'general.error.load.customer'})});
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      customerApi.getCustomer(nextProps.id)
        .then(customer => {
          customer.customerContactsWorkingCopy = cloneDeep(customer.customerContacts);
          this.setState({customer: customer});
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.loaded && prevState.organization.length < this.state.organization.length) {
      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
    }
  }

  onAddressChange = (newAddress, verified) => {
    let address = unformatAddress(newAddress);
    let customer = this.state.customer;

    customer.address1 = address.address1;
    customer.address2 = address.address2;
    customer.city = address.city;
    customer.state = address.state;
    customer.zip = address.zip;
    customer.addressVerified = verified ? 1 : 0;

    this.setState({
      customer,
    });

    //this.checkCustomerUnique();
  };

  onCustomerChange = e => {
    let customer = this.state.customer;
    let keys = Object.keys(customer);

    if (e.key === 'address') {
      customer = new Customer(Object.assign({}, customer.clone(), e.value));
      //Checks if unique address on change, still allows save event
      //this.checkCustomerUnique();
    } else if (keys.includes(e.key)) {
      customer[e.key] = e.value;
    }

    this.setState({customer});
  };

  openLinkNewTab = url => {
    let win = window.open(url, '_blank');

    win.focus();
  };

  getContactSection = () => {
    let {formatMessage} = this.props.intl;

    let phoneDescriptionOptions = [
        { value: null, id: null},
        ...Object.entries(phoneDescriptionLookup).map(([key, value]) => ({
          value: key,
          id: <FormattedMessage id={value} />
        }))
    ];

    let contacts = this.state.customer.customerContacts.map((contact, index) => {

      if(this.state.dealer.country === countries.CA) {
        contact.optInBiolabEmails = contact.optInBiolabEmails === undefined ? false : contact.optInBiolabEmails;
        contact.optInDealerEmails = contact.optInDealerEmails === undefined ? false : contact.optInDealerEmails;
      }

      if (contact.deleted) {
        return null;
      }

      const langSelected = locale => contact.contactEmailPreferences.emailLanguagePreference === locale ||
        !contact.contactEmailPreferences.emailLanguagePreference && this.state.dealer.defaultLocale === locale;

      const usedApprovedEmailByCustomerContact = email => {
        const contactsWithEmail = this.state.customer.customerContactsWorkingCopy.filter(c => c.email === email);
        //check if exist a contact within the same customer that is using the same email and has been saved before with checks

        return contactsWithEmail.map(c => c.email).includes(email) && contactsWithEmail.some(c => (!!c.created ||  !!c.modified || !!c.imported) && !c.deleted);
      };

      return <div key={index}
                  ref={index}
                  className='panel panel-default'>
        <div className='row panel-body'>
          <div className='col-md-6 contact-name-height'>
            <div className='form-group'>
              <label><FormattedMessage id='customer.name'/><span className='error'
                                                                 style={{marginLeft: 2}}>{this.state.organization[index] ? '' : '*'}</span></label>
              <div className='row'>
                <div className='col-sm-6 col-md-6'>
                  <EditableTextField ref={'nameFirst.' + index}
                                     className='form-control'
                                     type='text'
                                     maxLength='50'
                                     placeholder={formatMessage({id: 'general.first.name'})}
                                     editMode={true}
                                     value={contact.nameFirst}
                                     required={!this.state.organization[index]}
                                     group={this.group}
                                     onChange={this.changeContactField(index, 'nameFirst')}/>
                </div>
                <div className='col-sm-6 col-md-6'>
                  <EditableTextField ref={'nameLast.' + index}
                                     className='form-control'
                                     type='text'
                                     maxLength='50'
                                     placeholder={formatMessage({id: 'general.last.name'})}
                                     editMode={true}
                                     value={contact.nameLast}
                                     required={!this.state.organization[index]}
                                     group={this.group}
                                     onChange={this.changeContactField(index, 'nameLast')}/>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6'
               style={{height: '75px'}}>
            <div className='form-group'>
              <label className='editable-checkbox-blocklabel pointer'>
                <span className='editable-checkbox-label'
                        style={{fontWeight: 600}}>
                  <FormattedMessage id='customer.organization'/>
                  <span className='error'
                        style={{marginLeft: 2}}>{this.state.organization[index] ? '*' : ''}</span>
                </span>
              </label>
              <div className='checkbox-wrapper edit-customer-checkbox'>
                <input type='checkbox'
                       checked={this.state.organization[index]}
                       onChange={this.updateOrganization.bind(this, index)}/>
                <label/>
              </div>
              <div className='editableTextField-wrapper'>
                {/* Using visible property here instead of just not adding to the dom so the validation lifecycle stuff fires in the correct order. */}
                <EditableTextField ref={'organization.' + index}
                                   className='form-control'
                                   type='text'
                                   maxLength='100'
                                   editMode={true}
                                   group={this.group}
                                   value={contact.organization}
                                   placeholder={formatMessage({id: 'customer.organization.placeholder'})}
                                   required={true}
                                   onChange={this.changeContactField(index, 'organization')}
                                   visible={this.state.organization[index]}/>
              </div>
            </div>
          </div>
          <div className='col-md-6'
               style={{height: '75px'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.email'/>{this.state.dealer.requireCustomerEmail ?
                <span className='error'
                      style={{marginLeft: 2}}>*</span> : null}</label>
              <EditableTextField ref={'email.' + index}
                                 className='form-control'
                                 type='email'
                                 maxLength='100'
                                 editMode={true}
                                 onBlur={this.checkContactUnique.bind(this, index)}
                                 data-type='email'
                                 group={this.group}
                                 dataKey='email'
                                 onChange={this.changeContactField(index, 'email')}
                                 validate={isValidEmail}
                                 validateMessage={<FormattedMessage id='general.email.validation'/>}
                                 value={contact.email}
                                 required={this.state.dealer.requireCustomerEmail}/>
            </div>
          </div>
          <div className='col-md-6'
               style={{height: '75px'}}>
            <div className='form-group languages-wrapper'>
              <label><FormattedMessage id='general.emails.preferences'/><span className='error'
                                                                              style={{marginLeft: 2}}>*</span></label>
              <a onClick={() => this.updateEmailLanguage(contact, 'en-US')}>
                <LayoutCheckbox
                  dataKey='languageEnglish'
                  disabled={langSelected('en-US')}
                  key='languageEnglish'
                  label={<FormattedMessage id='general.language.english'/>}
                  value={langSelected('en-US')}
                />
              </a>
              <a onClick={() => this.updateEmailLanguage(contact, 'fr-CA')}>
                <LayoutCheckbox
                  dataKey='languageFrench'
                  disabled={langSelected('fr-CA')}
                  key='languageFrench'
                  label={<FormattedMessage id='general.language.french'/>}
                  value={langSelected('fr-CA')}
                />
              </a>
            </div>
          </div>
          <div className='col-md-6'
               style={{height: '75px'}}>
            <div className='form-group'>
              <label>
                  <FormattedMessage id='general.phone.number'/>
                  <span className='error'style={{marginLeft: 2}}>*</span>
                  <span className='dim n'>&nbsp;(<FormattedMessage id='general.primary'/>)</span>
              </label>
              <div className='row'>
                <div className='col-sm-6 col-md-6'>
                  <EditableTextField ref={'homePhone.' + index}
                                    className='form-control'
                                    type='text'
                                    maxLength='20'
                                    editMode={true}
                                    value={contact.homePhone}
                                    dataKey='homePhone'
                                    data-type='phone'
                                    group={this.group}
                                    format={phoneFormat}
                                    validate={isValidPhone}
                                    validateMessage={<FormattedMessage id='general.phone.validation'/>}
                                    onBlur={this.checkContactUnique.bind(this, index)}
                                    onChange={this.changeContactField(index, 'homePhone')}
                                    required={true}/>
                </div>
                <div className='col-sm-6 col-md-6'>
                  <LayoutSelect
                    noLabel={true}
                    editMode={true}
                    keys={phoneDescriptionOptions.map(opt => opt.value)}
                    options={phoneDescriptionOptions.map(opt => opt.id)}
                    value={contact.homePhoneDescription}
                    required={true}
                    dataChanged={this.changeContactField(
                      index,
                      "homePhoneDescription"
                    )}
                    validate={value => value !== null}
                    group={this.group}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6'
               style={{height: '75px'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.phone.number'/>
                <span className='dim n'>&nbsp;(<FormattedMessage id='general.alternate'/>)</span>
              </label>
              <div className='row'>
                <div className='col-sm-6 col-md-6'>
                  <EditableTextField ref={'workPhone.' + index}
                                    className='form-control'
                                    type='text'
                                    maxLength='20'
                                    editMode={true}
                                    value={contact.workPhone}
                                    dataKey='workPhone'
                                    format={phoneFormat}
                                    validate={v => !v || isValidPhone(v)}
                                    validateMessage={<FormattedMessage id='general.phone.validation'/>}
                                    data-type='phone'
                                    group={this.group}
                                    onChange={this.changeContactField(index, 'workPhone')}/>
                </div>
                <div className='col-sm-6 col-md-6'>
                  <LayoutSelect
                    noLabel={true}
                    editMode
                    dataChanged={this.changeContactField(
                      index,
                      "workPhoneDescription"
                    )}
                    keys={phoneDescriptionOptions.map(opt => opt.value)}
                    options={phoneDescriptionOptions.map(opt => opt.id)}
                    value={contact.workPhoneDescription}
                    required={contact.workPhone}
                    validate={value => value !== null}
                    group={this.group}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6'
               style={{height: '75px'}}>
            <div className='form-group'>
              <label><FormattedMessage id='general.phone.number'/>
                <span className='dim n'>&nbsp;(<FormattedMessage id='general.alternate'/>)</span>
              </label>
              <div className='row'>
                <div className='col-sm-6 col-md-6'>
                  <EditableTextField ref={'mobilePhone.' + index}
                                    className='form-control'
                                    type='text'
                                    maxLength='20'
                                    editMode={true}
                                    data-type='phone'
                                    group={this.group}
                                    value={contact.mobilePhone}
                                    format={phoneFormat}
                                    validate={v => !v || isValidPhone(v)}
                                    validateMessage={<FormattedMessage id='general.phone.validation'/>}
                                    onChange={this.changeContactField(index, 'mobilePhone')}/>
                </div>
                <div className='col-sm-6 col-md-6'>
                  <LayoutSelect
                    noLabel={true}
                    editMode
                    dataChanged={this.changeContactField(
                      index,
                      "mobilePhoneDescription"
                    )}
                    keys={phoneDescriptionOptions.map(opt => opt.value)}
                    options={phoneDescriptionOptions.map(opt => opt.id)}
                    value={contact.mobilePhoneDescription}
                    required={contact.mobilePhone}
                    validate={value => value !== null}
                    group={this.group}
                  />
                </div>
              </div>
            </div>
          </div>
          <DeleteConfirm
            confirmText={formatMessage({id: 'customer.remove.contact'})}
            onDelete={this.deleteContact.bind(this, index)}/>
          {this.state.dealer.country === countries.CA && contact.email && isValidEmail(contact.email) && !usedApprovedEmailByCustomerContact(contact.email) ?
            <div className='col-md-12'>
              <div className='form-group casl-wrapper'>
                <EditableCheckbox editMode={true} value={contact.optInBiolabEmails} required group={this.group} onChange={this.changeContactField(index, 'optInBiolabEmails')} validateMessage={formatMessage({id: 'customer.contact.casl.error'})}>
                  <FormattedMessage id="customer.contact.casl.optInBiolabEmails" />
                </EditableCheckbox>

                <EditableCheckbox editMode={true} value={contact.optInDealerEmails} required group={this.group} onChange={this.changeContactField(index, 'optInDealerEmails')} validateMessage={formatMessage({id: 'customer.contact.casl.error'})}>
                  <FormattedMessage id="customer.contact.casl.optInDealerEmails" />
                </EditableCheckbox>
              </div>
            </div> :
          null}
          <div className='col-md-12'>
            <div className='form-group'>
              {!!this.state.dealer && this.state.dealer.country === countries.CA ?
                <div>
                  <FormattedMessage id='customer.contact.pptou.ca' values={{brand: <span style={{whiteSpace: 'nowrap'}}>{brand}</span>}}/>
                  <br/><br/>
                  <FormattedMessage id='customer.contact.pptou.links'
                          values={{linkOne: <Link label={this.state.links[0]} action={() => this.openLinkNewTab(this.state.links[0])}/>,
                            linkTwo: <Link label={this.state.links[1]} action={() => this.openLinkNewTab(this.state.links[1])}/>,
                            linkThree: <Link label={this.state.links[2]} action={() => this.openLinkNewTab(this.state.links[2])}/>,
                            linkFour: <Link label={this.state.links[3]} action={() => this.openLinkNewTab(this.state.links[3])}/>,
                          }} />
                </div>              :
                <FormattedMessage id='customer.contact.pptou.us' values={{brand: <span style={{whiteSpace: 'nowrap'}}>{brand}</span>}}/>
              }
            </div>
          </div>
        </div>
      </div>;
    });

    return <div>
      <span className='pull-right'
              style={{marginTop: '10px'}}
              onClick={this.edit}>
          + <a className='pointer'
               onClick={this.addContact}><FormattedMessage id='customer.add.contact'/></a>
        <ToolTip title={formatMessage({id: 'customer.add.contact.tooltip'})}
                   position={tooltipPositions.topRight}
                   iconOnly/>
      </span>
      <h2><FormattedMessage id='customer.contact.information'/></h2>
      {contacts}
    </div>;
  };

  updateEmailLanguage = (contact, lang) => {
    let customer = this.state.customer;

    customer.customerContacts.forEach(c => {
      if (c.id !== contact.id) {
        return;
      }

      // if (c.contactEmailPreferences.emailLanguagePreference === lang) {
      //   return;
      // }

      c.contactEmailPreferences.emailLanguagePreference = lang;
      this.setState({customer: customer});
    }, this);
  };

  getCustomerSection = () =>
    <div>
      <h2><FormattedMessage id='customer.profile'/></h2>
      <div className='well'>
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label><FormattedMessage id='general.alexid'/></label>
              <EditableTextField type='text'
                                 className='form-control'
                                 editMode={true}
                                 group={this.group}
                                 maxLength='20'
                                 ref='accountNum'
                                 value={this.state.customer.accountNum || this.state.customer.defaultAccountNum}
                                 dataKey='accountNum'
                                 onChange={this.onCustomerChange}/>
            </div>
          </div>
          <div className='col-md-6'>
            <FullAddress ref={r => this.address = r}
                         dealer={this.state.dealer}
                         address={this.state.address}
                         verified={this.state.customer.addressVerified === 1 || this.state.customer.addressVerified === 2}
                         changeFunction={this.onAddressChange}
                         blurFunction={this.checkCustomerUnique}
            />
          </div>
        </div>
      </div>
    </div>;

  addContact = () => {
    let customer = this.state.customer;

    customer.customerContacts.push(new CustomerContact({}));
    let organization = this.state.organization.slice(0);

    organization.push(false);
    this.setState({customer: customer, organization: organization});
  };

  changeContactField = (index, field) => {
    return event => {
      let val = event.value;
      let customer = this.state.customer;

      customer.customerContacts[index][field] = val;
      this.setState({customer: customer});
    };
  };

  changeEmail = (index, event) => {
    event.preventDefault();
    let customer = this.state.customer;

    customer.customerContacts[index].email = event.value;
    this.setState({customer});
  };

  changeSystemField = (index, field, value = '') => {
    let val = value;
    let customer = this.state.customer;

    if (!customer || !customer.pools || !customer.pools[index]) {
      return;
    }

    customer.pools[index][field] = val;
    this.setState({customer});
    session.deletePool(customer.pools[index]);
  };


  getDuplicateFieldsTranslations = (duplicateFields) => {

    return duplicateFields && duplicateFields.length ?
      duplicateFields.map((field,index) =>  {
        return <React.Fragment key={`${field}-${index}`}>
          {index > 0 && index < duplicateFields.length ?
            <span>&nbsp;<FormattedMessage id='connector.and'/>&nbsp;</span> :
          null}
          <FormattedMessage key={index} id={field}/>
        </React.Fragment>;
      }) :
      <FormattedMessage id='tools.calibration.field'/>;
  }

  checkContactUnique = key => {
    let customerContacts = this.state.customer.customerContacts;
    let customerID = this.state.customer.id;

    customerApi.checkUniqueContact(
      customerContacts[key].id,
      customerContacts[key].homePhone,
      customerContacts[key].email)
      .then(data => {
        data = data.filter(x => x ? x.CustomerID !== customerID : x);
        let duplicateFields = [];

        if (data.length > 0) {
          if (data.some(x => x.HomePhone && onlyNumbers(x.HomePhone) === onlyNumbers(customerContacts[key].homePhone))) {
            duplicateFields.push('general.phone.number');
          }

          if (data.some(x => x.Email && x.Email === customerContacts[key].email)) {
            duplicateFields.push('general.email');
          }
        }

        if (data.length > 0) {
          events.publish('warn.user', {
            message: <FormattedMessage id='customer.error.duplicate.profile'
                                       values={{
                                         field: <span>{this.getDuplicateFieldsTranslations(duplicateFields)}</span>,
                                         link: <a href={`#customers/duplicates-${data.map(x => x.CustomerID + '-' + x.ID).join(',')}`}>
                                           <FormattedMessage id='general.click.here.capital'/>
                                         </a>,
                                       }} />,
          });
          this.setState({hasFoundDupe: true});
        } else {
          this.setState({hasFoundDupe: false});
        }
      });
  };

  checkCustomerUnique = () => {
    if (this.state.customer.address1 !== this.state.lastAddress) {
      this.setState({lastAddress: this.state.customer.address1});

      customerApi.checkUniqueCustomer(this.state.customer.id, this.state.customer.address1)
        .then(data => this.sendAlertMsg(data || []));
    }
  };

  deleteContact = index => {
    let customer = this.state.customer;

    customer.customerContacts[index].deleted = true;
    this.setState({customer: customer});
  };

  deleteCustomer = () => {
    customerApi.deleteCustomer(this.state.customer)
      .then(() => window.location.hash = 'customers')
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'general.error.delete.customer'})});
      });
  };

  save = () => {
    // Prevents double save
    if (this.state.submitted) {
      return;
    }

    this.setState({submitted: true});

    let customer = this.state.customer;

    if (customer.accountNum === customer.defaultAccountNum) {
      customer.accountNum = null;
    }

    if(!customer.accountNum && !!customer.defaultAccountNum) {
      customer.accountNum = customer.defaultAccountNum;
    }

    if (customer.customerContacts.filter(x => !x.deleted).length === 0) {
      events.publish('error.user', {message: this.props.intl.formatMessage({id: 'customer.error.contact.null'})});
      return;
    }

    customerApi.saveCustomer(customer)
      .then(customer => {
        window.location.hash = window.location.hash = `#/customer/${customer.id}`;
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'customer.error.not.saved'})});
        this.setState({submitted: false});
      });
  };

  sendAlertMsg = data => {
    data = data.filter(x => x);
    const addressUniquenessKey = 'customer-address';

    if (data.length > 1) {
      events.publish('warn.user', {
        message: <span><FormattedMessage id='customer.address.entered'/> &quot;{data[0].Address1}&quot;
          <FormattedMessage id='customer.error.appears.several'/>
          &nbsp;
          <a href={`#customers/duplicates-${data.map(x => x.ID).join(',')}`}><FormattedMessage id='general.click.here'/></a>
          &nbsp;<FormattedMessage id='customer.error.customer.list'/></span>,
        uniquenessKey: addressUniquenessKey,
      });
      this.setState({hasFoundDupe: true});
    } else if (data.length === 1 && this.state.customer.id) {
      events.publish('warn.user', {
        message: <span><FormattedMessage id='customer.address.entered'/> &quot;{data[0].Address1}&quot;
          &nbsp;<FormattedMessage id='customer.error.appears.profile'/>
          &nbsp;
          <a href={`#tools/accounts/merge-customer/${this.state.customer.id}/${data[0].ID}`}>
            <FormattedMessage id='general.click.here'/></a> <FormattedMessage id='customer.error.merge.match'/></span>,
        uniquenessKey: addressUniquenessKey,
      });
      this.setState({hasFoundDupe: true});
    } else if (data.length === 1) {
      events.publish('warn.user', {
        message: <span><FormattedMessage id='customer.address.entered'/> &quot;{data[0].Address1}&quot;
          &nbsp;<FormattedMessage id='customer.error.appears.profile'/>
          &nbsp;
          <a href={`#customer/${data[0].ID}`}><FormattedMessage id='general.click.here'/></a> <FormattedMessage id='customer.error.go.other'/></span>,
        uniquenessKey: addressUniquenessKey,
      });
    } else if (data.length === 0) {
      this.setState({hasFoundDupe: false});
    }
  };

  toggleFavourite = () => {
    let customer = this.state.customer;

    customer.favourite = !customer.favourite;
    if (this.props.id) {
      customerApi.saveCustomer(customer)
        .catch(() => events.publish('error.user', {message: this.props.intl.formatMessage({id: 'general.error.save.favourite'})}));
    }

    this.setState({customer: customer});
  };

  unverifyAddress = event => {
    let customer = this.state.customer;

    if (customer.addressVerified) {
      customer.addressVerified = false;
    }
    let keys = Object.keys(customer);

    if (keys.includes(event.key)) {
      customer[event.key] = event.value;
    }
    this.setState({customer: customer});
  };

  updateOrganization = (index, event) => {
    let organization = this.state.organization;

    organization[index] = event.target.checked;
    let customer = this.state.customer;

    customer.customerContacts[index].organization = ''; // Clear org field as well, not just checkbox
    this.setState({organization, customer});
  };

  render() {
    let pageTitle = '';
    let contact = null;
    let {formatMessage} = this.props.intl;

    if (isNaN(this.props.id)) {
      pageTitle = formatMessage({id: 'customer.search.new'});
    } else if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }
      let contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;

      if (this.state.customer.inactive) {
        pageTitle = <span>{(contactName || '').trim()}
          <span className='inactive'>({formatMessage({id: 'general.inactive'})})</span></span>;
      } else {
        pageTitle = <span>{(contactName || '').trim()} </span>;
      }
    }

    let customerUrl = this.props.id;

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    let systemWidgets;

    if (this.props.id) {
      systemWidgets = <CustomerPools
        pools={this.state.customer.pools}
        customer={this.state.customer}
        dealer={this.state.dealer}
        contact={contact}
        edit={true}
        onChange={this.changeSystemField}/>;
    }

    return <div id='page-customer'
                className={'container' + (this.state.editMode ? ' editing' : '')}>
      <Header mainTitle={formatMessage({id: 'customer.analysis.title'})}
              mainTitleReturn='customers'
              subTitle={pageTitle}>
      </Header>

      <form onSubmit={this.group.validate}>
        <Loader loaded={this.state.loaded}>
          <div className='row'>
            {this.props.id ?
              <div>
                <div className='col-md-8'>
                  {this.getCustomerSection()}
                  {this.getContactSection()}
                </div>
                <div className='col-md-4'>
                  {systemWidgets}
                </div>
              </div> :
              <div className='col-md-12'>
                {this.getCustomerSection()}
                {this.getContactSection()}
              </div>
            }
          </div>
        </Loader>

        <PageFooter>
          {this.props.id ?
            <NoteFooter customer={this.state.customer} /> :
            null}
          <FooterDeleteButton onDelete={this.deleteCustomer}
                              enabled={!!this.props.id}
                              label={formatMessage({id: 'customer.delete'})}/>
          <FooterButton
            label={formatMessage({id: 'general.email'})}
            icon='footer-item-icon bl bl-2x bl-email'
            enabled={false}/>
          <FooterButton
            label={this.state.customer.inactive ? formatMessage({id: 'general.inactive'}) : formatMessage({id: 'general.active'})}
            icon={this.state.customer.inactive ? 'bl bl-toggle-off fa-2x' : 'bl bl-toggle-on fa-2x'}
            enabled={false}/>
          <span className='footer-item footer-edit-options'>
            <i className='footer-item-icon bl bl-edit fa-2x'/>
            <FormattedMessage id='general.edit'/>
            &nbsp;
            {this.props.id ?
              <button type='button'
                      className='btn btn-default'
                      onClick={() => window.location.hash = path.join(window.location.hash, '..')}>
                <FormattedMessage id='general.cancel'/></button> :
              <button type='button'
                      className='btn btn-default'
                      onClick={() => window.location.hash = '/customers/'}><FormattedMessage id='general.cancel'/>
              </button>
            }
            <button type='submit'
                    className='btn btn-primary'><FormattedMessage id='general.save'/></button>
          </span>
          <FooterButton label={formatMessage({id: 'general.print'})}
                        icon='bl bl-2x bl-print'
                        enabled={false}/>
        </PageFooter>
      </form>
    </div>;
  }
}

const WrappedCustomerEditPage = injectIntl(CustomerEditPage);

export default WrappedCustomerEditPage;
